import { type LucideIcon } from "lucide-react";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}

export function EmptyState({ icon: Icon, title, description, actionLabel, onAction }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-10 text-center">
      <Icon size={32} className="text-text-tertiary mb-3" />
      <h3 className="text-[17px] font-medium text-text-primary mb-1">{title}</h3>
      <p className="text-[14px] text-text-secondary max-w-sm">{description}</p>
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          className="mt-4 px-4 py-2 bg-brand text-white rounded-xl text-[16px] font-medium"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}
